import { client } from "src/services/client";

export const fetchUserInfo = async (query: any) =>
    client({
        method: query.method,
        url: `/profile/${query.endpoint}`,
        headers: { "Content-Type": "application/json" },
        data: query.body,
    }).then((response) => response.data);
